import util from '../util'

let controller = 'EnvioDeEmailTemplate'
export default Object.assign({}, util.GetCrud(controller, ['get', 'getall', 'post', 'put', 'persist', 'delete']), {
    Combo: function () {
        return util.Axios.Get(controller + '/Combo')
    }
})
